<template>
  <div v-if="item">
    <div class="border" v-if="$store.state.user.is_root">
      <h4>Редактирование статуса</h4>
      <fields-list :simple="true" :item="item" :fields="fields" />

      <p class="mb-3">
        Перед сохранением - убедитесь, что статус соотвествует текущему статусу
      </p>
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>

    <ul v-if="!loading">
      <li v-for="(i, k) in info" :key="k">
        <h5>
          <span class="text-info">{{ i.title }}: </span>
          <span class="" v-if="i.type == 'text'">
            {{ getSubObject(item, i.key) }}
          </span>
          <span class="" v-if="i.type == 'bts-statuses'">
            <bts-statuses :id="item[i.key]" />
          </span>
        </h5>
      </li>
    </ul>
    <div v-else>
      <h3>Обновление данных...</h3>
    </div>
    <containers :id="id" />
    <component
      :is="item.service.code"
      :data="item"
      @input="serviceupdateItemData"
      @update="serviceupdateItemData"
    />
  </div>
</template>
<script>
import {
  cardUpdate,
  cardContent,
  errorNotify,
  toFormData,
} from "@/plugins/functions";

export default {
  components: {
    Containers: () => import("./Containers.vue"),
    bts: () => import("@/components/Services/bts"),
  },
  computed: {
    lastUpdate() {
      return this.$store.state.lastUpdate;
    },
  },
  data: () => ({
    loading: false,
    cardLink: "transfers",
    cardSetLink: "transfers",
    item: null,
    // case 'new':
    //             return 'В процессе';
    //         case 'sent':
    //             return 'Оформлено';
    //         case 'done':
    //             return 'В пути';
    //         case 'cancel':
    //             return 'Отменено';
    //         case 'received':
    //             return 'Получено';
    //         default:
    fields: [
      {
        key: "status",
        label: "Статус",
        type: "static_radio",
        items: [
          { id: "new", title: "В процессе" },
          { id: "sent", title: "Оформлено" },
          { id: "done", title: "В пути" },
          { id: "cancel", title: "Отменено" },
          { id: "received", title: "Получено" },
        ],
      },
    ],
    info: [
      {
        key: "display_status",
        title: "Статус",
        type: "text",
      },
      {
        key: "exchange_status_id",
        title: "Статус парнера",
        type: "bts-statuses",
      },
      {
        key: "sender_name",
        title: "Отправитель",
        type: "text",
      },
      {
        key: "sender_phone",
        title: "Отправитель (номер телефона)",
        type: "text",
      },

      {
        key: "user.name",
        title: "Ответственный",
        type: "text",
      },
      {
        key: "user.phone",
        title: "Номер телефона (ответственный)",
        type: "text",
      },
      {
        key: "shop.name",
        title: "Торговая точка",
        type: "text",
      },
      {
        key: "shop.address",
        title: "Адрес",
        type: "text",
      },

      {
        key: "weight",
        title: "Общий вес",
        type: "text",
      },
      {
        key: "volume",
        title: "Общий объем",
        type: "text",
      },
    ],
  }),

  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    async serviceupdateItemData(val) {
      setTimeout(() => {
        this.$loading(true);
      }, 1);
      return this.$http({
        method: "post",
        data: toFormData({ _method: "put", ...val }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$store.dispatch("setLastUpdate", new Date());
          console.log(response.data.data);
          this.item = response.data.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 200);
        });
    },
    getSubObject(item, key) {
      let keys = key.split(".");
      let result = item;

      for (let i = 0; i < keys.length; i++) {
        if (result && result.hasOwnProperty(keys[i])) {
          result = result[keys[i]];
        } else {
          return "";
        }
      }
      return result;
    },
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item) {
        this.item = item;
      }
    },
  },
  watch: {
    async lastUpdate(val) {
      if (val) {
        this.loading = true;
        this.item = await this.cardContent(this.cardLink, this.id);
        this.loading = false;
      }
    },
  },
};
</script>
